module.exports = __webpack_public_path__ + "img/slide01.a68ab583.jpg";